import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useNativeWebViewInsets } from "../context/NativeWebViewInsetsContext";
import { Reveal } from "../theme/animation";

const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.smsp.myapp&pcampaignid=smsp-homepage";

const STORE_LINKS = [
    {
        id: "google-play",
        href: PLAY_STORE_URL,
        badgeSrc: "/images/googleplay.png",
        alt: "Get it on Google Play"
    }
] as const;

/**
 * Invites web visitors to download the native app. Hidden inside the app WebView.
 */
const DownloadApps: React.FC = () => {
    const { isNativeWebView } = useNativeWebViewInsets();

    if (isNativeWebView) {
        return null;
    }

    return (
        <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: "background.default" }}>
            <Container maxWidth="md" sx={{ textAlign: "center" }}>
                <Reveal variant="fadeUp">
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            mb: 2,
                            fontWeight: 800,
                            color: "primary.main",
                            fontSize: { xs: "1.75rem", md: "1.9rem" }
                        }}
                    >
                        Get the SMSP app
                    </Typography>
                </Reveal>
                <Reveal variant="fadeUp" delay={0.08}>
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 3,
                            lineHeight: 1.7,
                            fontSize: "1.05rem",
                            color: "text.primary",
                            maxWidth: 560,
                            mx: "auto"
                        }}
                    >
                        Take Strong Mind Strong Performance with you. Check in, follow your lesson
                        plans, and stay connected from your phone.
                    </Typography>
                </Reveal>
                <Reveal variant="fadeUp" delay={0.16}>
                    <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1
                    }}
                >
                    {STORE_LINKS.map((store) => (
                        <Box
                            key={store.id}
                            component="a"
                            href={store.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-attr={`download-apps_${store.id}`}
                            aria-label={store.alt}
                            sx={{
                                display: "inline-flex",
                                lineHeight: 0,
                                textDecoration: "none",
                                "&:hover, &:focus": {
                                    textDecoration: "none",
                                    opacity: 0.9
                                }
                            }}
                        >
                            <Box
                                component="img"
                                src={store.badgeSrc}
                                alt={store.alt}
                                sx={{
                                    height: { xs: 64, sm: 80 },
                                    width: "auto",
                                    display: "block"
                                }}
                            />
                        </Box>
                    ))}
                </Box>
                </Reveal>
            </Container>
        </Box>
    );
};

export default DownloadApps;
